import type { ThemePalette } from '../schema/MiniPalette';

// Base dark theme palette from: https://microsoft.sharepoint.com/teams/yammerandroidteam94/Shared%20Documents/Forms/AllItems.aspx?id=%2Fteams%2Fyammerandroidteam94%2FShared%20Documents%2FApps%2FYammer%2FShared%20Colors%2Epdf&parent=%2Fteams%2Fyammerandroidteam94%2FShared%20Documents%2FApps%2FYammer

export const BASE_DARK_THEME_PALETTE: ThemePalette = {
    themeDarker: '#6CB8F6',
    themeDark: '#3AA0F3',
    themeDarkAlt: '#1890F1',
    themePrimary: '#0086F0',
    themeSecondary: '#2488d8',
    themeTertiary: '#0078D4',
    themeLight: '#004C87',
    themeLighter: '#043862',
    themeLighterAlt: '#092C47',

    // Common
    sidePaneSelectedBackground: '#212121',
    headerBackground: '#212121',
    headerButtonBackground: '#141414',
    headerButtonPressedBackground: '#303030',
    headerSearchBarBackground: '#303030',
    headerSearchBarButtonPressedBackground: '#212121',

    // Mail
    activePillBg: '#404040',
    activePillFg: '#ffffff',
    inactivePillBg: '#141414',
    inactivePillFg: '#e1e1e1',
    activePillBgOnThemeBg: '#404040',
    activePillFgOnThemeBg: '#ffffff',
    inactivePillBgOnThemeBg: '#141414',
    inactivePillFgOnThemeBg: '#e1e1e1',
    toastBg: '#0086F0',

    //Selection
    selection: '#206AA1',
};
